import React from 'react';
import PropTypes from 'prop-types';

const Card = props => (
  <div className={`card ${props.cardClass}`}>
    <div className="header">
      {props.table ? props.filtro : ''}
      <div className="category">{props.category}</div>
    </div>
    <div className={`content ${props.contentClass}`}>
      <div id={props.id} className={props.classes}>
        {props.content}
      </div>
      <div className="footer">
        {props.legend}
        {props.stats != null ? <hr /> : ''}
        <div className="stats">
          <i className={props.statsIcon} /> {props.stats}
        </div>
      </div>
    </div>
  </div>
);

Card.propTypes = {
  id: PropTypes.string.isRequired,
  //table: PropTypes.string.isRequired,
  //filtro: PropTypes.string.isRequired,
  //category: PropTypes.string.isRequired,
  classes: PropTypes.string.isRequired,
  //content: PropTypes.string.isRequired,
  //legend: PropTypes.string.isRequired,
  //stats: PropTypes.string.isRequired,
  //statsIcon: PropTypes.string.isRequired,
  //contentClass: PropTypes.string.isRequired,
  //cardClass: PropTypes.string.isRequired
};

export default Card;
